import React from 'react';

import TenantConfigurationContainer from '@src/components/tenant/TenantConfigurationContainer';

const AdminTenantPage = () => <TenantConfigurationContainer />;

export default AdminTenantPage;
